import type { PaginationLabels } from '@shared';

/** Etiquetas en español de la barra de paginación del admin, para
 *  `<DataTable paginated paginationLabels={ADMIN_PAGINATION_LABELS} />` y para
 *  `Paginator`. Vivían en `AdminPagination.tsx`, un componente que nadie
 *  usaba: sólo se importaba esta constante. */
export const ADMIN_PAGINATION_LABELS: PaginationLabels = {
  perPage: 'por página',
  showing: 'Mostrando',
  to: 'a',
  of: 'de',
  page: 'Página',
  prevPage: 'Página anterior',
  nextPage: 'Página siguiente',
  nav: 'Paginación',
  pageSize: 'Elementos por página',
};
